import React, { useState, useEffect } from "react";
import "./BonusLevel.css";
import axios from "axios";
import Cookies from "js-cookie";
import baseURL from "../../config";
import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";

const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  const secretKey = '19092002'; 
  const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
  const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

  return decryptedToken || null;
};
const token = getDecryptedToken();

const BonusLevel = () => {
  const { userId, theme } = useParams();
  const [bonusData, setBonusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showRulesPopup, setShowRulesPopup] = useState(false);

  useEffect(() => {
    const fetchBonusPoints = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/BonusPoints/GetPointsByUserId`,
          {
            params: { id: userId },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setBonusData(response.data);
      } catch (error) {
        console.error("Error fetching bonus points:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBonusPoints();
  }, [userId]);
  
  useEffect(() => {
    // Set body class based on theme
    if (theme === "light") {
      document.body.classList.add("light-theme");
    } else {
      document.body.classList.remove("light-theme");
    }
  
    return () => {
      document.body.classList.remove("light-theme");
    };
  }, [theme]);

  const toggleRulesPopup = () => {
    setShowRulesPopup(!showRulesPopup);
  };

  if (loading) return <p>Loading...</p>;
  if (!bonusData?.success) return <p>Error loading bonus points.</p>;

  const currentLevel = bonusData.levels.find((lvl) => lvl.isCurrent) || bonusData.levels[0];
  const nextLevel = bonusData.levels.find((lvl) => lvl.levelId === currentLevel.levelId + 1);
  const pointsNeeded = nextLevel ? nextLevel.minPoints - bonusData.bonusPoints.remaining : 0;

  const containerClass = theme === "light" ? "bonus-container-light" : "bonus-container";
  const activeClass = theme === "light" ? "active-light" : "active";
  const inactiveClass = theme === "light" ? "inactive-light" : "inactive";
  const bodybackground = theme === "light" ? "bodybackground-light" : "bodybackground";

  return (
    <div className={bodybackground}>
    
    {showRulesPopup && (
  <div className={`rules-popup ${theme === "light" ? "rules-popup-light" : ""}`}>
    <div className="rules-popup-content">
      <h3 className="rules-popup-title">RREGULLAT E PROGRAMIT SPORT&FASHION BONUS</h3>
      <div className="rules-popup-body">
        <div className="rules-section">
          <h4 className="rules-subtitle">ORGANIZATORËT</h4>
          <p className="rules-text">
            Shoqëritë As Sport SH.P.K dhe HILGROUP SH.P.K, me adresë Preoc, Zona Kadastrale Krxhile, Prishtinë, Kosovë, janë krijuesit dhe kontrolluesit e Programit Sport&Fashion Bonus (më poshtë do të referohet si "Programi"), krijuesit e sistemit të pikëve dhe kontrollues të bazës së të dhënave personale për të gjithë përdoruesit e regjistruar të programit.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">PJESËMARRJA</h4>
          <p className="rules-text">
            Programi funksionon nëpërmjet aplikacionit Sport&Fashion Bonus, i cili mund të shkarkohet falas në AppStore dhe PlayStore. Çdo individ mbi 18 vjeç, banor në Kosovë, që regjistrohet në aplikacion dhe pranon kushtet e programit, bëhet automatikisht pëfitues i Programit.
          </p>
          <p className="rules-text">
            Duke u regjistruar dhe duke pranuar termat përmes aplikacionit, individi konfirmon që pajtohet me të gjitha rregullat e Programit. Të gjitha informacionet e dhëna gjatë regjistrimit duhet të jenë të sakta dhe të vërteta. Përdoruesi është përgjegjës për të dhënat e tij personale dhe për çdo aktivitet në aplikacionin e tij.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">PARTNERËT</h4>
          <p className="rules-text">
            Partnerët e Programit janë të gjithë subjektet që kanë nënshkruar marrëveshje bashkëpunimi me As Sport SH.P.K dhe HILGROUP SH.P.K për funksionimin e Programit, duke përfshirë përpunimin dhe menaxhimin e të dhënave të përdoruesve në emër të tyre.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">NDRYSHIME NË PROGRAM</h4>
          <p className="rules-text">
            Shoqëritë mbajnë të drejtën të ndryshojnë, pezullojnë ose ndërpresin çdo pjesë të Programit në çdo kohë, pa paralajmërim. Të gjitha ndryshimet do të publikohen në aplikacion dhe në faqen zyrtare http://www.sportas.shop/sportandfashionbonus-terms. Nëse përdoruesi vazhdon të përdorë aplikacionin pas ndryshimeve, kjo konsiderohet si pranim i kushteve të reja.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">SISTEMI I PIKËVE DHE NIVELIT</h4>
          <p className="rules-text">
            Programi ka 5 nivele të pikëve, me vlerë të ndryshme për çdo nivel. Përdoruesi fiton pikë për çdo blerje në pikat partnere, duke skanuar barkodin përpara pagesës.
          </p>
          <div className="points-table">
            <table>
              <thead>
                <tr>
                  <th>Niveli</th>
                  <th>Pikët</th>
                  <th>Vlera e një Pike</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Niveli 1</td>
                  <td>0 – 199</td>
                  <td>€ 0.07</td>
                </tr>
                <tr>
                  <td>Niveli 2</td>
                  <td>200 – 399</td>
                  <td>€ 0.10</td>
                </tr>
                <tr>
                  <td>Niveli 3</td>
                  <td>400 – 699</td>
                  <td>€ 0.12</td>
                </tr>
                <tr>
                  <td>Niveli 4</td>
                  <td>700 – 1099</td>
                  <td>€ 0.17</td>
                </tr>
                <tr>
                  <td>Niveli 5</td>
                  <td>1100+</td>
                  <td>€ 0.22</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="rules-text">
            Pikët janë të vlefshme për 6 muaj nga data e blerjes që i gjeneron ato. Pas kësaj periudhe, ato skadojnë automatikisht dhe nuk mund të përdoren.
          </p>
          <p className="rules-text">
            Çdo nivel do të shfaqet veçmas në aplikacion me vlerën përkatëse në euro. Një vlerë totale e përgjithshme për të gjitha nivelet e pikëve do të shfaqet në aplikacion. Pikët nuk mund të shtohen manualisht nëse barkodi nuk është skanuar përpara pagesës. Pikët nuk janë të transferueshme dhe nuk mund të shndërrohen në para.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">PËRFITIME SHTESË</h4>
          <ul className="rules-list">
            <li>Çdo përdorues i ri përfiton automatikisht 5% zbritje në çdo blerje me përdorimin e aplikacionit.</li>
            <li>Produkte me ulje të veçantë në aplikacion.</li>
            <li>Dhurata promocionale në formën e shpërblimeve.</li>
            <li>Nëse përdoruesi arrin më shumë se 2000 pikë, mund të përfitojë stimuj të tjerë shtesë (dhurata, ulje të personalizuara, etj.).</li>
          </ul>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">TË DHËNAT PERSONALE</h4>
          <p className="rules-text">
            As Sport SH.P.K dhe HILGROUP SH.P.K mbledhin dhe përpunojnë këto të dhëna: emër, mbiemër, datëlindje, gjini, numër telefoni, adresë emaili. Të dhënat përpunohen për:
          </p>
          <ul className="rules-list">
            <li>Personalizim ofertash dhe zbritjesh</li>
            <li>Studim të zakoneve të blerjes</li>
            <li>Dërgim të njoftimeve promocionale</li>
            <li>Analizë të sjelljes së konsumatorit</li>
          </ul>
          <p className="rules-text">
            Të dhënat ruhen në serverë të sigurt. Të gjitha palët janë të detyruara të respektojnë ligjin për mbrojtjen e të dhënave personale.
          </p>
          <p className="rules-text">
            Përdoruesi mund të kërkojë në çdo kohë qasje, përditësim ose fshirje të të dhënave personale përmes aplikacionit ose duke kontaktuar shërbimin e klientit.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">SIGURIA DHE ANULIMI</h4>
          <p className="rules-text">
            Në rast të humbjes ose vjedhjes së telefonit, përdoruesi duhet të ndryshojë fjalëkalimin ose të kontaktojë mbështetjen për të bllokuar aksesin dhe për të transferuar pikët.
          </p>
          <p className="rules-text">
            Nëse përdoruesi i programit nuk raporton humbjen apo vjedhjen e telefonit, AS Sport sh.p.k. dhe HILGROUP sh.p.k. nuk janë përgjegjës për ndonjë keqpërdorim ose humbje të pikëve.
          </p>
          <p className="rules-text">
            Përdoruesi ka të drejtë të anulojë pjesëmarrjen në program në çdo kohë përmes aplikacionit ose duke kontaktuar shërbimin e klientit. Pas anulimit, të dhënat fshihen përgjithmonë nga sistemi.
          </p>
          <p className="rules-text">
            Në rast të anulimit të Programit, përdoruesi ka të drejtë të përdorë pikët e mbetura brenda 30 ditëve nga njoftimi.
          </p>
          <p className="rules-text">
            Shoqëritë kanë të drejtë të përjashtojnë përdorues nga programi në rast të abuzimit ose shkeljes së kushteve, me ose pa njoftim paraprak.
          </p>
        </div>

        <div className="rules-section">
          <h4 className="rules-subtitle">KONTAKT</h4>
          <p className="rules-text">
            Për çdo pyetje, ndihmë teknike ose informacione të mëtejshme, përdoruesi mund të kontaktojë në çdo kohë shërbimin e klientit ose të vizitojë faqen zyrtare <a href="http://www.sportas.shop/sportandfashionbonus-terms" target="_blank" rel="noopener noreferrer">http://www.sportas.shop/sportandfashionbonus-terms</a>.
          </p>
        </div>
      </div>
      <button 
        className="rules-popup-close"
        onClick={toggleRulesPopup}
      >
        Mbyll
      </button>
    </div>
  </div>
)}
      
      <div className={containerClass}>
        <h2 className="bonus-title">Nivel i bonusit</h2>
        <div className="bonus-box gradient-bg">
          <div className="bonus-level">
            NIVELI
            <span className="level-number">{currentLevel.levelId}</span>
          </div>
          <p className="bonus-points">
            PIKE: {Math.floor(bonusData.bonusPoints.remaining)}
          </p>
          <p className="euro-worth">
            EUR: {(currentLevel.pointsValue * bonusData.bonusPoints.remaining).toFixed(2)}
          </p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${(bonusData.bonusPoints.remaining / currentLevel.maxPoints) * 100}%`,
              }}
            ></div>
          </div>
          {currentLevel.levelId === 5 ? (
            <p className="points-needed">Keni arritur levelin maksimal</p>
          ) : (
            nextLevel && (
              <p className="points-needed">
                {pointsNeeded} pikë për të arritur në Nivelin {nextLevel.levelId}
              </p>
            )
          )}

        </div>
        <div className="level-indicators">
          {bonusData.levels.map((lvl) => (
            <div
              key={lvl.levelId}
              className={`level-circle ${lvl.isCurrent ? activeClass : inactiveClass}`}
            >
              {lvl.levelId}
            </div>
          ))}
        </div>
        
        <button 
          className={`rules-button ${theme === "light" ? "rules-button-light" : ""}`}
          onClick={toggleRulesPopup}
        >
          Rregullat e Përdorimit
        </button>
        
        
      </div>
    </div>
  );
};

export default BonusLevel;